export enum AccessKeyError {
  NOT_EXIST = 'NOT_EXIST',
  API_ERROR = 'API_ERROR',
  LIMIT_ERROR = 'LIMIT_ERROR',
  DUPLICATE_ERROR = 'DUPLICATE_ERROR',
  REVOKE_ERROR = 'REVOKE_ERROR',
}
